export enum NotificationType {
  INFO = 'info',
  WARNING = 'warn',
  ERROR = 'error'
}
